import { InView } from 'react-intersection-observer';
import style from '../knear.module.scss'
import Image from 'next/image'
import animations from '@styles/animations.module.scss'

interface StartSectionProps {
    title: string;
    subtitle: string;
    text: Array<string>;
    image: string;
}
const StartSection = ({ title, subtitle, text, image }: StartSectionProps) => {
    return (<section className={`${style.section} ${style.section_light}`}>
        <div className={`${style.container}`}>
            <InView triggerOnce={true}>
                {({ inView, ref, entry }: any) => {
                    if (inView) {
                        entry?.target.classList.add(animations.active);
                    }
                    return (
                        <h1 ref={ref} className={`${style.container__title} ${style.brand} ${animations.scroll__animation}`}>
                            {title}
                        </h1>
                    )
                }}
            </InView>
            <InView triggerOnce={true}>
                {({ inView, ref, entry }: any) => {
                    if (inView) {
                        entry?.target.classList.add(animations.active);
                    }
                    return (
                        <h2 ref={ref} className={`${style.container__subtitle} ${animations.scroll__animation}`}>
                            {subtitle}
                        </h2>
                    )
                }}
            </InView>
            <InView triggerOnce={true}>
                {({ inView, ref, entry }: any) => {
                    if (inView) {
                        entry?.target.classList.add(animations.active);
                    }
                    return (
                        <div ref={ref} className={`${animations.scroll__animation} ${style.container__image}`}>
                            <Image sizes="800px 200px" layout={'fill'} src={image} alt={title} />
                        </div>
                    )
                }}
            </InView>
            {
                text.map((item: string, index: number) => {
                    return (
                        <div key={index} className={`${style.container__text}`}>
                            <InView triggerOnce={true}>
                                {({ inView, ref, entry }: any) => {
                                    if (inView) {
                                        entry?.target.classList.add(animations.active);
                                    }
                                    return (
                                        <div ref={ref} className={`${animations.scroll__animation}`}>
                                            {item}
                                        </div>
                                    )
                                }}
                            </InView>
                        </div>
                    )
                })
            }
        </div>
    </section>
    )
}

export default StartSection;
